import URL from '../url'
import Request from '../request'

export const getLocalizationStringsService = languageCode =>
  new Request(
    URL.API,
    URL.GET_LOCALIZATION_STRINGS.replace('{languageCode}', languageCode),
  ).get()
